{
  "title": "Әмиян",
  "subtitle": "Баланс тек серверден оқылады. Нақты операциялар қосылмаған.",
  "real": "Негізгі баланс",
  "bonus": "Бонус",
  "reserved": "Резерв",
  "unavailable": "Баланс ақпараты қолжетімсіз",
  "deposit": "Депозит",
  "withdraw": "Шығару",
  "history": "Тарих",
  "comingSoon": "Төлем ағындары жақында"
}
